import React from 'react';
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle, IonIcon,
  IonSkeletonText,
} from "@ionic/react";
import {Tarefa} from "../../models/Tarefa";
import {DateTime} from "luxon";
import {Principal} from "../../models/Principal";
import {usePrincipal} from "../../lib/hooks";
import styles from "./TarefaCard.module.css";
import {useHistory} from "react-router";
import {actions} from "../../lib/app";
import {useAppDispatch} from "../../lib/hooks";
import {EventoObject} from "../../models/Evento";
import truncate from "lodash/truncate";
import {checkboxOutline, openOutline, squareOutline} from "ionicons/icons";
import fb from "../../lib/firebase";
import ConfirmationButton from "../../components/ConfirmationButton";
import {sanitizeText} from "../../lib/utils";

interface TarefaCardProps {
  tarefa: Tarefa;
}

const TarefaCard: React.FC<TarefaCardProps> = (props) => {
  const {tarefa} = props;
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [principal, principalIsLoading] = usePrincipal<Principal>(tarefa.principal);
  const [evento, eventoIsLoading] = usePrincipal<EventoObject>(tarefa.evento);

  const onClickPrincipal = () => {
    dispatch(actions.jump('/agenda'));
    history.push(`/${tarefa.principal.path}/home`);
  }

  const onClickEvento = () => {
    dispatch(actions.jump('/agenda'));
    history.push(`/${tarefa.evento.path}/home`);
  }

  const onToggle = async () => {
    const concluido = !tarefa.concluido;
    await fb.document.update('agenda', tarefa.id, {concluido});
  }

  const isLoading = principalIsLoading || eventoIsLoading || !principal || !evento;

  return (
    <>
      <IonCard

      >
        <IonCardHeader>
          <IonCardSubtitle>
            <div className="flex justify-between items-center">
              <div>
                {tarefa.tipo}
              </div>
              <div className="text-base font-bold">
                {DateTime.fromJSDate(tarefa.data.toDate()).toFormat('dd/MM/yyyy')}
              </div>
            </div>
          </IonCardSubtitle>
          <IonCardTitle>
            {tarefa.descricao}
          </IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <div>
            {isLoading &&
              <div className="flex flex-col gap-1">
                <IonSkeletonText animated />
                <IonSkeletonText animated style={{width: '70%'}} />
                <IonSkeletonText animated style={{width: '40%'}} />
              </div>
            }
            {principal && evento &&
              <div className="flex flex-col gap-4">
                <Detalhe label="Tipo de cliente" info={principal.label}/>
                <Detalhe
                  label="Cliente"
                  info={
                    <div
                      className="flex justify-between items-center cursor-pointer hover:bg-gray-50"
                      onClick={onClickPrincipal}
                    >
                      <div>
                        {principal._fullName}
                      </div>
                      <div className="pr-2">
                        <IonIcon src={openOutline} className="text-xl"/>
                      </div>
                    </div>
                  }
                />
                <Detalhe
                  label="Evento de origem"
                  info={
                    <div
                      className="flex justify-between items-center cursor-pointer hover:bg-gray-50"
                      onClick={onClickEvento}
                    >
                      <div>
                        {DateTime.fromJSDate(evento.data.toDate()).toFormat('dd/MM/yyyy')}
                      </div>
                      <div className="pr-2">
                        <IonIcon src={openOutline} className="text-xl"/>
                      </div>
                    </div>
                  }
                />
                {evento.proximo_contato_notas &&
                  <div className="bg-red-100 p-2 text-black rounded">
                    {truncate(sanitizeText(evento.proximo_contato_notas), {length: 100})}
                  </div>
                }
              </div>
            }
          </div>
          <div className="flex items-center gap-6 justify-center mt-4 h-9">
            {principal && evento &&
              <>
                {!tarefa.concluido &&
                  <ConfirmationButton
                    shape="round"
                    size="small"
                    className={styles.btAction}
                    color="success"
                    onConfirm={onToggle}
                    icon={checkboxOutline}
                    message="Você tem certeza que deseja marcar esta tarefa como concluída?"
                  >
                    Concluído
                  </ConfirmationButton>
                }
                {tarefa.concluido &&
                  <ConfirmationButton
                    shape="round"
                    size="small"
                    className={styles.btAction}
                    color="danger"
                    onConfirm={onToggle}
                    icon={squareOutline}
                    message="Você tem certeza que deseja retornar esta tarefa para a lista de pendentes?"
                  >
                    Não concluído
                  </ConfirmationButton>
                }
              </>
            }
          </div>
        </IonCardContent>
      </IonCard>
    </>
  );
}

export default TarefaCard;


const Detalhe = ({label, info}: {label: string, info: any}) => {
  return (
    <div className="w-full">
      <div className="font-condensed font-bold opacity-50 leading-none text-sm">
        {label}
      </div>
      <div className="font-condensed truncate leading-none">
        {info}
      </div>
    </div>
  )
}